import React from 'react'
import {Flex} from '/app/src/component'
import CubeFold from './FoldingCube'
import FadingCircle from './FadingCircle'
import FountainDrops from './FountainDrops'
import Bounce from './Bounce'

// http://tobiasahlin.com/spinkit/#
class Spinner extends React.Component
{
    render()
    {
        let {type, text} = this.props
        let spinner;
        switch(type){
            case 'circle':
                spinner = <FadingCircle/>
                break;
            case 'cubefold':
                spinner = <CubeFold/>
                break;
            case 'bounce':
                spinner = <Bounce/>
                break;
            case 'fountaindrops':
                spinner = <FountainDrops />
                break;
            case 'cubegrid':
            default:
                spinner = <Bounce/>
        }

        return (
            <Flex column
                width='100%' height='100%'
                hAlignContent='center' vAlignContent='center'>

                <Flex>
                    {spinner}
                </Flex>
                {text && (
                <Flex>
                    {text}
                </Flex>
                )}

            </Flex>
        );
    }
}
Spinner.defaultProps = {
    type: 'cubegrid' // cubegrid, cubefold, circle,
}

export default Spinner



// WEBPACK FOOTER //
// src/component/Spinner/index.js